import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SidebarService } from '@ibe/services/ui';
import { BookedTrip } from '@ibe/models';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, AbstractControl, ValidatorFn } from '@angular/forms';
import { MybService } from '@ibe/services';
import { HttpClient } from '@angular/common/http';
import { takeWhile } from 'rxjs/operators';
import { Subscription, Observable } from 'rxjs';
import * as fromStore from '../../../../store';
import { Store } from '@ngrx/store';

import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAContactsService } from '@ibe.services/contact-details.indra.services';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { INDRAParallelService } from '@ibe.services/parallel.indra.service';

import { SelectInputOption } from '@ibe.components/common/inputs/select-input-indra/models/select-input-option';
import { CookieService } from 'ngx-cookie-service';
import { COOKIES_VAR_KEY_PASSENGER_DETAILS, COOKIES_VAR_KEY_PASSENGER_CONTACT_DETAILS, COUNTRIES_TRANSLATION_KEY } from '@ibe.config';
import * as _ from 'lodash';


/*
import { DiscardModalComponent } from '@ibe.components/shared/passengers-discard-modal/discard-modal.component';
import { CountryCode } from '@ibe.models/country-code.model';
import { ModalService, SidebarService } from '@ibe/services/ui';

import { Observable, Subscription } from 'rxjs';
import * as ContactsActions from '../../../../store/actions/contacts.actions';
*/

@Component({
	selector: 'app-contacts',
	templateUrl: './contacts.indra.component.html',
	styleUrls: ['./contacts.component.scss']
})
export class INDRAContactsComponent implements OnInit, OnDestroy {
	// Page status variables
	private isAlive: boolean = true;
	private pnrExists = false;
	private triedToSubmit = false; // To know if we should show errors or not
	private triggerCreatePassenger$: Observable<boolean> = this.parallelService.triggerCreatePassenger$;
	private triggerCreateContact$: Observable<boolean> = this.parallelService.triggerCreateContact$;

	triggerCreatePassenger: boolean = false;
	triggerCreateContact: boolean = false;

	isBookedTripsLoaded = false;
	isContactsInfoLoaded = false;
	isServiceLoading = false;
	MAX_PHONE_CONTACTS = 1;
	
	// Corp
	// isCorporate$: Observable<boolean> = this.store.select(fromStore.getIsCorporate);
	isCorporate: boolean = false;
	// newEmployee: boolean = true;

	// Data variables
	contactsInfo: any;
	booked_trip: BookedTrip;
	pnr: string;
	countryCodes = [];
	loadedSubscription: Subscription;
	subForm1Subscription: Subscription;
	subForm2Subscription: Subscription;
	editContactSubscription: Subscription;
	allSubs: Subscription[] = [];
	
	/*  note: from post-sprint 8 client code merge
	userEmployee: String = '';
	employees = [
		{ label: 'Choose other passenger', value: '' },
		{ label: 'Mr. Francisco Cabral (fcabral@sonae.com)', value: 'fcabral' },
		{ label: 'Mrs. Ana Patrícia Santos (apsantos@sonae.com)', value: 'apsantos' },
		{ label: 'Mr. Antonio Silva (asilva@sonae.com)', value: 'asilva' },
		{ label: 'Dr. Maria Sayonara (msayonara@sonae.com)', value: 'msayonara' },
		{ label: 'Mr. Mário Rodrigues (mrodrigues@sonae.com)', value: 'mrodrigues' },
		{ label: 'Mrs. Nádia Ferreira (nferreira@sonae.com)', value: 'nferreira' },
		{ label: 'Mrs. Olívia Palmira (opalmira@sonae.com)', value: 'opalmira' },
		{ label: 'Mr. Rui Pinto (rpinto@sonae.com)', value: 'rpinto' }
	];
	*/

	notif = {
		icon: '',
		title: 'TAP',
		message: 'bookingDetails.text.somethingWentWrong',
		style: 'error',
		show: false,
		showCloseBtn: true
	};
	showNotif: boolean = false;

	private userInfo: any;

	public isBookingPaymentPage: boolean = false;

	public countryCodeOptions: any[] = [];
	public contactTypes: SelectInputOption[] = [
		{text: this.INDRA_getTranslation('bookingDetails.text.home'), value: 6 },
		{text: this.INDRA_getTranslation('bookingDetails.text.mobile'), value: 10 },
		{text: this.INDRA_getTranslation('bookingDetails.text.business'), value: 7 }
	];

	userInfoCookie: any;
	hasCookies: boolean = false;
	dataFromCookie: boolean = false;
	isUSAFlight: boolean = false;
	hasEmailError: string = '';

	constructor(
		private store: Store<fromStore.State>,
		private fb: FormBuilder,
		private sidebarService: SidebarService,
		private mybService: MybService,
		private route: ActivatedRoute,
		private router: Router,
		protected _http: HttpClient,
		private bfmStorage: INDRABFMDataStorageService,
		private ibeAdminService: INDRAIbeAdminService,
		private contactService: INDRAContactsService,
		private cdr: ChangeDetectorRef,
		private storage: INDRAStorageService,
		private cookieService: CookieService,
		private bookingService: INDRABookingService,
		private parallelService: INDRAParallelService,
	) {
		/* note: from post-sprint 8 client code merge
		this.isCorporate$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(data => {
				this.isCorporate = data;
			});
		*/
	}

	// Generic form group
	group: FormGroup;

	// Emergency Contact form variables
	formBookingContacts = {
		group: this.group,
		hasChanges: false,
		hasErrors: false,
		isEmpty: false,
		hasData: false
	};

	formBookingContactsSecondary = { group: this.group };

	/**********************************/
	/* Initialize variables functions */
	/**********************************/

	ngOnInit() {
		if (this.router.url.includes('/booking/payment') || this.router.url.includes('/time-to-think/payment')) {
			this.isBookingPaymentPage = true;
		}
		
		const booked_trip = this.bfmStorage.INDRA_getActiveBookedTrip();
		this.isUSAFlight = this.bookingService.INDRA_isUSAFlight(booked_trip);
		
		this.INDRA_getCountryCodes();
		this.userInfo = this.storage.get('userData');

		// Get URL parameters
		this.pnr = this.route.snapshot.paramMap.get('pnr');

		// Check if PNR exists (= completed booking)
		if (this.pnr !== undefined) {
			this.pnrExists = true;
			this.contactsInfo = this.bfmStorage.INDRA_getActiveBookInfoPax();
		}

		const contactDetails = this.cookieService.check(COOKIES_VAR_KEY_PASSENGER_CONTACT_DETAILS);
		if (contactDetails) {
			this.hasCookies = true;
		}

		if (this.hasCookies && !this.userInfo && this.contactsInfo.email == null && this.contactsInfo.phone == null) {
			const cookieData = JSON.parse(atob(this.cookieService.get(COOKIES_VAR_KEY_PASSENGER_CONTACT_DETAILS)));
			const tempData = _.cloneDeep(this.contactsInfo);
			tempData.email = cookieData.email;
			tempData.verify_email = cookieData.email;
			tempData.phone = cookieData.phone;
			tempData.phoneCountryCode = cookieData.phoneCountryCode;
			tempData.phoneType = cookieData.phoneType;
			tempData.prefixPhone = cookieData.prefixPhone;
			tempData.secondaryTelephones = cookieData.secondaryTelephones;
			tempData.selectGDPR = cookieData.selectGDPR;
			this.dataFromCookie = true;
			this.contactsInfo = _.cloneDeep(tempData);
		}
		const self = this;
		// Subscribe to know when the mocked trips are loaded
		this.loadedSubscription = this.mybService.isBookedTripsLoaded.pipe(takeWhile(() => this.isAlive)).subscribe(data => {
			this.isBookedTripsLoaded = data;
			if (this.isBookedTripsLoaded) {
				self.getBooking.call(self);
			}
		});

		// Create form
		this.INDRA_createFormClasses();
		this.INDRA_createSecondaryFormClasses();

		this.subForm1Subscription = this.formBookingContacts.group.statusChanges.subscribe(change => {
			if (change) {
				this.INDRA_formChanges();
			}
		});
		this.subForm2Subscription = this.formBookingContactsSecondary.group.statusChanges.subscribe(change => {
			if (change) {
				this.INDRA_formChanges();
			}
		});

		const triggerCreatePassengerSubscription = this.triggerCreatePassenger$.subscribe(value => {
			this.triggerCreatePassenger = value;
		});

		const triggerCreateContactSubscription = this.triggerCreateContact$.subscribe(value => {
			this.triggerCreateContact = value;
		});

		this.allSubs.push(this.loadedSubscription);
		this.allSubs.push(this.subForm1Subscription);
		this.allSubs.push(this.subForm2Subscription);
		this.allSubs.push(triggerCreatePassengerSubscription);
		this.allSubs.push(triggerCreateContactSubscription);

		if (this.hasCookies && !this.userInfo && this.dataFromCookie) {
			this.formBookingContacts.hasChanges = true;
		}
	}

	INDRA_getCountryCodes() {
		const URL = './assets/data/indra_country_codes.json';
		const countryCodeSubscription = this._http.get(URL).subscribe(
			(data: any) => {
				this.countryCodes = data;
				this.countryCodeOptions = this.INDRA_getCountryCodesOptions(this.countryCodes);
				this.cdr.detectChanges();
			}
		);
		this.allSubs.push(countryCodeSubscription);
	}

	ngOnDestroy() {
		this.isAlive = false;
		for (const sub of this.allSubs) {
			sub.unsubscribe();
		}
	}

	trackByFn(index, item) {
		return index; // or item.id
	}

	/**
	 * Create form group
	 */
	INDRA_createFormClasses() {
		// Check if passenger has contact data in the booking
		// Initialize as null if not
		if (this.contactsInfo === undefined || this.contactsInfo === null ||
			(this.contactsInfo.phone === null && this.contactsInfo.email === null)) {
			// Update has no data variable
			this.formBookingContacts.hasData = false;
			// Initialize as null
			this.contactsInfo = {
				email: null,
				verify_email: null,
				primary_phone: {
					type: null,
					prefix: null,
					number: null
				},
				secondaryTelephones: [],
				selectGDPR: null
			};
			this.formBookingContacts.isEmpty = true;
		} else {
			this.formBookingContacts.hasData = true;
			this.formBookingContacts.isEmpty = false;
		}

		// Create form group ith controls and validators
		this.formBookingContacts = Object.assign({}, this.formBookingContacts, {
			group: new FormGroup(
				{
					email: new FormControl(
						this.contactsInfo.email,
						{
							validators: [
								Validators.required,
								Validators.email,
								Validators.pattern("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")
							],
							updateOn: 'blur',
						}
					),
					verify_email: new FormControl(
						this.contactsInfo.verify_email,
						{
							validators: [
								Validators.required,
								Validators.email,
								Validators.pattern("^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"),
								this.INDRA_VerifyEmail
							],
							updateOn: 'blur',
						}
					),
					phone_type: new FormControl(
						this.contactsInfo.phoneType
						, [Validators.required]
					),
					phone_prefix: new FormControl(
						this.INDRA_composePrefixFormValue(this.contactsInfo.prefixPhone, this.contactsInfo.phoneCountryCode), 
						[Validators.required]
					),
					phone_number: new FormControl(
						this.contactsInfo.phone,
						[Validators.required, Validators.pattern('[0-9]+')]
					),
					selectGDPR: new FormControl(
						this.contactsInfo.selectGDPR,
						[Validators.required]
					)
				}
			)
		});

		this.formBookingContacts.group.get('email').valueChanges.subscribe(() => {
			this.formBookingContacts.group.get('verify_email').updateValueAndValidity();
		});

		this.formBookingContacts.hasChanges = false;
	}

	INDRA_cancelEditFormContacts() {
		this.formBookingContacts.group.controls['email'].setValue(
			this.contactsInfo.email
		);
		this.formBookingContacts.group.controls['verify_email'].setValue(
			this.contactsInfo.email
		);
		this.formBookingContacts.group.controls['phone_type'].setValue(
			this.contactsInfo.phoneType
		);
		this.formBookingContacts.group.controls['phone_prefix'].setValue(
			this.INDRA_composePrefixFormValue(this.contactsInfo.prefixPhone, this.contactsInfo.phoneCountryCode)
		);
		this.formBookingContacts.group.controls['phone_number'].setValue(
			this.contactsInfo.phone
		);
		const secondaryContacts = this.formBookingContactsSecondary.group.controls['items'] as FormArray;
		if (this.contactsInfo.secondaryTelephones && this.contactsInfo.secondaryTelephones.length > 0) {
			if (secondaryContacts.length > 0) {
				// this.contactsInfo.secondaryTelephones.length limit to 1
				for (let index = 0; index < 1; index++) {

					(secondaryContacts.at(index) as FormArray).controls['type'].setValue(
						this.contactsInfo.secondaryTelephones[index].type
					);
					(secondaryContacts.at(index) as FormArray).controls['prefix'].setValue(
						this.INDRA_composePrefixFormValue(this.contactsInfo.secondaryTelephones[index].countryCode, this.contactsInfo.secondaryTelephones[index].region)
					);
					(secondaryContacts.at(index) as FormArray).controls['number'].setValue(
						this.contactsInfo.secondaryTelephones[index].telephone
					);
				}
			} else {
				// this.contactsInfo.secondaryTelephones.length limit to 1
				for (let index = 0; index < 1; index++) {
					(this.formBookingContactsSecondary.group.controls['items'] as FormArray).push(this.createSecondaryContact(index));
				}
			}
		} else {
			this.formBookingContactsSecondary.group = this.fb.group({
				items: this.fb.array([])
			});
		}
		this.formBookingContacts.hasErrors = false;
		this.formBookingContacts.hasChanges = false;


	}

	INDRA_showCancelButton() {
		return (!this.isBookingPaymentPage && (this.formBookingContacts.hasChanges || this.formBookingContacts.hasErrors));
	}

	INDRA_addNewContact(): void {
		(this.formBookingContactsSecondary.group.controls[
			'items'
		] as FormArray).push(this.createSecondaryContact());
		this.formBookingContacts.hasChanges = true;
	}

	/**
	 * Create secondary phones form group
	 */
	INDRA_createSecondaryFormClasses() {
		// Check if passenger has emergency contact data in the booking
		// Initialize as null if not
		this.formBookingContactsSecondary.group = this.fb.group({
			items: this.fb.array([])
		});
		if (this.contactsInfo.secondaryTelephones && this.contactsInfo.secondaryTelephones.length > 0) {
			// this.contactsInfo.secondaryTelephones.length limit length to 1
			for (let index = 0; index < 1; index++) {
				(this.formBookingContactsSecondary.group.controls['items'] as FormArray).push(this.createSecondaryContact(index));
			}
		}
		this.formBookingContacts.hasChanges = false;
	}

	createSecondaryContact(index = null) {
		if (index === null) {
			return this.fb.group({
				type: [null, [Validators.required]],
				prefix: [null, [Validators.required]],
				number: [null, [Validators.required, Validators.pattern('[0-9]+')]],
				selectGDPR: [null, [Validators.required]],
			});
		} else {
			return this.fb.group({
				type: [this.contactsInfo.secondaryTelephones[index].type, [Validators.required]],
				prefix: [
					this.INDRA_composePrefixFormValue(this.contactsInfo.secondaryTelephones[index].region, this.contactsInfo.secondaryTelephones[index].countryCode),
					[Validators.required]],
				number: [this.contactsInfo.secondaryTelephones[index].telephone, [Validators.required, Validators.pattern('[0-9]+')]]
			});
		}
	}

	INDRA_getSecondaryPhones() {
		const ITEMS = <FormArray>this.formBookingContactsSecondary.group.controls['items'];
		return ITEMS.controls;
	}

	INDRA_removeContact(index) {
		(this.formBookingContactsSecondary.group.controls[
			'items'
		] as FormArray).removeAt(index);
		this.formBookingContacts.hasChanges = true;
	}

	INDRA_showAddNewButton() {
		const ITEMS = <FormArray>this.formBookingContactsSecondary.group.controls['items'];
		if (ITEMS !== undefined) {
			return ITEMS.controls.length < this.MAX_PHONE_CONTACTS;
		} else {
			return true;
		}
	}

	INDRA_formChanges() {
		this.triedToSubmit = false;
		this.formBookingContacts.hasChanges = true;
		this.formBookingContacts.isEmpty = false;
	}

	/**
	 * Returns class to a formControl if it's not valid
	 * @param {FormControl} formControl to check if has any error
	 * @returns {Object} with matched classes
	 */
	INDRA_hasErrors(control) {
		return {
			'has-error':
				this.formBookingContacts.group.controls[control].invalid &&
				this.triedToSubmit &&
				this.formBookingContacts.hasChanges
		};
	}

	/**
	 * Returns class to a formControl if it's not valid
	 * @param {FormControl} formControl to check if has any error
	 * @returns {Object} with matched classes
	 */
	INDRA_hasErrorsSecondaryPhones(control, index) {
		const ITEMS = <FormArray>this.formBookingContactsSecondary.group.controls['items'];
		const ITEMS_INDEX = <FormArray>ITEMS.controls[index];

		return {
			'has-error':
				ITEMS_INDEX.controls[control].invalid &&
				this.triedToSubmit &&
				this.formBookingContacts.hasChanges
		};
	}

	/**
	 * Check if a control is invalid to show error styles
	 */
	INDRA_formInvalid(control) {
		return (
			this.formBookingContacts.group.controls[control].invalid &&
			this.formBookingContacts.hasErrors &&
			this.triedToSubmit
		);
	}

	/**
	 * Check if a control is invalid to show error styles
	 */
	INDRA_formInvalidSecondaryPhones(control, index) {
		const ITEMS = <FormArray>this.formBookingContactsSecondary.group.controls['items'];
		const ITEMS_INDEX = <FormArray>ITEMS.controls[index];

		return (
			ITEMS_INDEX.controls[control].invalid &&
			this.formBookingContacts.hasErrors &&
			this.triedToSubmit
		);
	}

	/**
	 * Check if a control is invalid to show error messages
	 */
	INDRA_formErrors(control) {
		const errors = [];
		if (control === 'email') {
			if (this.formBookingContacts.group.controls[control].hasError('email')) {
				errors.push('bookingDetails.error.emailInvalid');
			}
			if (
				this.formBookingContacts.group.controls[control].hasError('required')
			) {
				errors.push('bookingDetails.error.emailRequired');
			}
		}
		if (control === 'phone_type') {
			if (
				this.formBookingContacts.group.controls[control].hasError('required')
			) {
				errors.push('bookingDetails.error.phoneTypeRequired');
			}
		}
		if (control === 'phone_prefix') {
			if (
				this.formBookingContacts.group.controls[control].hasError('required')
			) {
				errors.push('bookingDetails.error.phoneCountryCodeRequired');
			}
		}
		if (control === 'phone_number') {
			if (
				this.formBookingContacts.group.controls[control].hasError('pattern')
			) {
				errors.push('bookingDetails.error.phoneNumInvalid');
			}
			if (
				this.formBookingContacts.group.controls[control].hasError('required')
			) {
				errors.push('bookingDetails.error.phoneNumRequired');
			}
		}
		return errors.join('; ');
	}

	/**
	 * Check if a control is invalid to show error messages
	 */
	INDRA_formErrorsSecondaryPhones(control, index) {
		const ITEMS = <FormArray>this.formBookingContactsSecondary.group.controls['items'];
		const ITEMS_INDEX = <FormArray>ITEMS.controls[index];

		const errors = [];
		if (control === 'type') {
			if (
				ITEMS_INDEX.controls[control].hasError('required')
			) {
				errors.push('bookingDetails.error.phoneTypeRequired');
			}
		}
		if (control === 'prefix') {
			if (
				ITEMS_INDEX.controls[control].hasError('required')
			) {
				errors.push('bookingDetails.error.phoneCountryCodeRequired');
			}
		}
		if (control === 'number') {
			if (
				ITEMS_INDEX.controls[control].hasError('pattern')
			) {
				errors.push('bookingDetails.error.phoneNumInvalid');
			}
			if (
				ITEMS_INDEX.controls[control].hasError('required')
			) {
				errors.push('bookingDetails.error.phoneNumRequired');
			}
		}
		return errors.join('; ');
	}

	/**
	 * Save form
	 * Check if is valid and save or show errors if not
	 */
	INDRA_saveEditFormContacts() {
    if(this.parallelService.isGenerateApiLoading || this.parallelService.isCatalogueApiLoading) {
      return 
    }

		// Check if secondary contacs are valid
		let contactsSecondaryValid = true;
		if (this.formBookingContactsSecondary.group.controls['items'] !== undefined) {
			const ITEMS = <FormArray>this.formBookingContactsSecondary.group.controls['items'];

			for (let index = 0; index < ITEMS.length; index++) {
				const ITEMS_INDEX = <FormArray>ITEMS.controls[index];
				if (ITEMS_INDEX.controls['type'].invalid) {
					contactsSecondaryValid = false;
				}
				if (ITEMS_INDEX.controls['prefix'].invalid) {
					contactsSecondaryValid = false;
				}
				if (ITEMS_INDEX.controls['number'].invalid) {
					contactsSecondaryValid = false;
				}
			}
		}

		if (
			this.formBookingContacts.group.valid && contactsSecondaryValid ||
			(
				this.formBookingContacts.group.controls.email.valid &&
				this.formBookingContacts.group.controls.verify_email.valid &&
				this.formBookingContacts.group.controls.phone_type.valid &&
				this.formBookingContacts.group.controls.phone_prefix.valid &&
				this.formBookingContacts.group.controls.phone_number.valid &&
				contactsSecondaryValid &&
				this.formBookingContacts.group.controls.selectGDPR
			)
		) {
			this.formBookingContacts.hasErrors = false;
			// Save Edit Form
			this.contactsInfo = Object.assign({}, this.contactsInfo, {
				email: this.formBookingContacts.group.controls[
					'email'
				].value
			});

			const primary_phone = {
				type: this.formBookingContacts.group.controls['phone_type'].value,
				country: this.formBookingContacts.group.controls['phone_prefix'].value,
				number: this.formBookingContacts.group.controls['phone_number'].value
			};
			this.contactsInfo = Object.assign({}, this.contactsInfo, {
				phoneType: primary_phone.type,
				phoneCountryCode: primary_phone.country,
				phone: primary_phone.number
			});
			this.contactsInfo = Object.assign({}, this.contactsInfo, {
				selectGDPR: this.formBookingContacts.group.controls[
					'selectGDPR'
				].value
			});
			if (this.formBookingContactsSecondary.group.controls['items'] !== undefined && this.formBookingContactsSecondary.group.controls['items']['length'] > 0) {
				const ITEMS = <FormArray>this.formBookingContactsSecondary.group.controls['items'];

				this.contactsInfo.secondaryTelephones = []; // Reset secondary contacs
				let new_secondary_phones;

				for (let index = 0; index < ITEMS.length; index++) {
					const ITEMS_INDEX = <FormArray>ITEMS.controls[index];

					new_secondary_phones = {
						type: ITEMS_INDEX.controls['type'].value,
						countryCode: ITEMS_INDEX.controls['prefix'].value,
						telephone: ITEMS_INDEX.controls['number'].value
					};
					this.contactsInfo.secondaryTelephones.push(new_secondary_phones);
				}
			}
			this.INDRA_updatePassengerInfo();

			this.formBookingContacts.hasData = true;
		} else {
			this.formBookingContacts.hasErrors = true;
		}
		this.formBookingContacts.hasChanges = false;
	}

	/**
	 * Clear all data from with current Booking Passenger Info values
	 * {FormGroup} form.group
	 * {Array} form.fields
	 * @param {Object} form get values to reset
	 * @param {string} passengerInfoKey name of key to get current values from Booking
	 */
	INDRA_clearForm(): void {
		// primary contacts reset;
		this.formBookingContacts.group.get('email').setValue(null);
		this.formBookingContacts.group.get('verify_email').setValue(null);
		this.formBookingContacts.group.get('phone_type').setValue('');
		this.formBookingContacts.group.get('phone_prefix').setValue('');
		this.formBookingContacts.group.get('phone_number').setValue(null);

		// secondary contacts reset;
		if (this.formBookingContactsSecondary.group.controls['items'] !== undefined) {
			const ITEMS = <FormArray>this.formBookingContactsSecondary.group.controls['items'];

			for (let index = 0; index < ITEMS.length; index++) {
				const ITEMS_INDEX = <FormArray>ITEMS.controls[index];
				ITEMS_INDEX.get('type').setValue('');
				ITEMS_INDEX.get('prefix').setValue('');
				ITEMS_INDEX.get('number').setValue(null);
			}
		}
		this.formBookingContacts.hasErrors = false;
		this.formBookingContacts.hasChanges = true;
		this.formBookingContacts.isEmpty = true;
	}

	/**
	 * Checks if Clear button should be displayed
	 */
	INDRA_showClearButton() {
		return (!this.isBookingPaymentPage && (!this.formBookingContacts.isEmpty || this.formBookingContacts.hasErrors));
	}

	/**************************/
	/* Generic functions      */
	/**************************/

	/**
	 * Updates passenger info on data storage
	 */
	INDRA_updatePassengerInfo() {
		if (this.isBookingPaymentPage) {
			this.INDRA_callAPIForBookingSearchFlow();
		} else {
			this.INDRA_callAPIForMYBFlow();
		}
	}

	INDRA_callAPIForBookingSearchFlow() {
		
		const countryIndex = this.countryCodes.findIndex(
			(code) => {
				return (code.prefix + ':' + code.code)  === this.formBookingContacts.group.get('phone_prefix').value;
			}
		);
		const contactRequest = {
			emails: [this.formBookingContacts.group.get('email').value || ''],
			telephones: [
				{
					number: this.formBookingContacts.group.get('phone_number').value || '',
					prefix: this.countryCodes[countryIndex].prefix || '',
					type: parseInt(this.formBookingContacts.group.get('phone_type').value)
				},
			],
			selectGDPR: this.formBookingContacts.group.get('selectGDPR').value || false,

		};
		if (this.isUSAFlight) {
			contactRequest['esta'] = this.bfmStorage.INDRA_getTravelDocumentationConfirm();
			contactRequest['eta'] = this.bfmStorage.INDRA_getTravelHazmatBaggageRulesConfirm();
		}
		
		const secondaryContacts = (this.formBookingContactsSecondary.group.controls['items'] as FormArray);
		if (secondaryContacts.length > 0) {
			const pushContacts = secondaryContacts.at(0);
			contactRequest.telephones.push(
				{
					number: (pushContacts as FormArray).controls['number'].value,
					prefix: this.INDRA_isCountryPrefix((pushContacts as FormArray).controls['prefix'].value),
					type: parseInt((pushContacts as FormArray).controls['type'].value)
				}
			);
		} else {
			this.contactsInfo.secondaryTelephones = [];
		}

		this.isServiceLoading = true;
		this.parallelService.INDRA_setTriggerCreateContact(true);
		this.editContactSubscription = this.contactService.INDRA_CreateContacts(contactRequest)
			.subscribe(
				(data) => {
					this.isServiceLoading = false;
					if (data.status === '200') {
						this.INDRA_UpdateValues(contactRequest);
					} else {
						this.INDRA_showNotifications('error', 'Something went wrong. Try again later');
					}

				}, (error) => {
					this.isServiceLoading = false;
					this.INDRA_showNotifications('error', 'Something went wrong. Try again later');
				}
			);
		this.allSubs.push(this.editContactSubscription);
	}

	INDRA_callAPIForMYBFlow() {
		const countryIndex = this.countryCodes.findIndex(
			(code) => {
				return (code.prefix + ':' + code.code)  === this.formBookingContacts.group.get('phone_prefix').value;
			}
		);
		const contactRequest = {
			emails: [this.formBookingContacts.group.get('email').value || ''],
			idPax: '',
			pnr: this.bfmStorage.INDRA_getActiveBookedTrip().data.pnr,
			telephones: [
				{
					number: this.formBookingContacts.group.get('phone_number').value || '',
					prefix: this.countryCodes[countryIndex].prefix || '',
					type: parseInt(this.formBookingContacts.group.get('phone_type').value)
				}
			]
		};
		const secondaryContacts = (this.formBookingContactsSecondary.group.controls['items'] as FormArray);
		if (secondaryContacts.length > 0) {
			const pushContacts = secondaryContacts.at(0);
			contactRequest.telephones.push(
				{
					number: (pushContacts as FormArray).controls['number'].value,
					prefix: this.INDRA_isCountryPrefix((pushContacts as FormArray).controls['prefix'].value),
					type: parseInt((pushContacts as FormArray).controls['type'].value)
				}
			);
		} else {
			this.contactsInfo.secondaryTelephones = [];
		}
		this.isServiceLoading = true;
		this.editContactSubscription = this.contactService.INDRA_EditContacts(this.bfmStorage.INDRA_getActiveBookedTrip().data.pnr, contactRequest)
			.subscribe(
				(data) => {
					this.isServiceLoading = false;
					if (data.status === '200') {
						this.mybService.updateBooking(this.pnr, Object.assign({}, this.booked_trip, { contact_details: this.contactsInfo }));
						this.INDRA_UpdateValues(contactRequest);
					} else {
						this.INDRA_showNotifications('error', 'Something went wrong. Try again later');
					}
				},
				(error) => {
					this.isServiceLoading = false;
					this.INDRA_showNotifications('error', 'Something went wrong. Try again later');
				}
			);
		this.allSubs.push(this.editContactSubscription);
	}

	/**
	 * Get booking from service using PNR
	 */
	getBooking(): void {
		if (this.mybService.getBooking(this.pnr)) {
			this.booked_trip = this.mybService.getBooking(this.pnr);
			this.INDRA_getContactsInfo();
		}
	}

	/**
	 * Get passenger info from service using passenger ID
	 */
	INDRA_getContactsInfo() {
		this.contactsInfo = this.booked_trip.contact_details;
		this.isContactsInfoLoaded = true;
	}


	/**************************/
	/* Sidebar functions      */
	/**************************/

	/** Handles close action intention **/
	INDRA_handleClose() {
		this.sidebarService.closeSidebar(true);
		// this.router.navigate([{ outlets: { sidebar: null } }]);
	}

	/** Handles done action **/
	INDRA_handleDone() {
		this.INDRA_handleClose();
	}

	/**
	 * Check if Save button should be displayed
	 * Buttun shouls show if there are any change on any form on the sidebar
	 */
	INDRA_showSaveSidebarHeader() {
		return !this.isServiceLoading && this.formBookingContacts.hasChanges;
	}



	/** Handles done action **/
	INDRA_saveSidebar() {
		this.triedToSubmit = true;
		// Check if emergency Contact form is open
		if (this.formBookingContacts.hasChanges) {
			// this.INDRA_showNotifications("success", "Saving, Please wait...", false)
			this.INDRA_saveEditFormContacts();
		}
	}

	INDRA_getTranslation(key: string): string {
		return this.ibeAdminService.getTranslationValue(key);
	}

	INDRA_UpdateValues(contactRequest: any) {
		const dataHolder = _.cloneDeep(this.bfmStorage.INDRA_getActiveBookedTrip());
		dataHolder.data.infoPax.email = contactRequest.emails[0];
		dataHolder.data.infoPax.verify_email = contactRequest.emails[0];
		dataHolder.data.infoPax.phone = contactRequest.telephones[0].number;
		dataHolder.data.infoPax.prefixPhone = this.INDRA_isCountryCode(this.contactsInfo.phoneCountryCode);
		dataHolder.data.infoPax.phoneCountryCode = this.INDRA_isCountryPrefix(this.contactsInfo.phoneCountryCode);
		dataHolder.data.infoPax.phoneType = contactRequest.telephones[0].type;
		dataHolder.data.infoPax.selectGDPR = contactRequest.selectGDPR;
		if (contactRequest.telephones[1]) {
			if (dataHolder.data.infoPax.secondaryTelephones && dataHolder.data.infoPax.secondaryTelephones !== null) {
				dataHolder.data.infoPax.secondaryTelephones[0] = {
					countryCode: this.INDRA_isCountryPrefix(this.contactsInfo.secondaryTelephones[0].countryCode),
					telephone: contactRequest.telephones[1].number,
					type: contactRequest.telephones[1].type,
					region: this.INDRA_isCountryCode(this.contactsInfo.secondaryTelephones[0].countryCode),
					tattoo: ''
				};
			} else {
				dataHolder.data.infoPax.secondaryTelephones = [{
					countryCode: this.INDRA_isCountryPrefix(this.contactsInfo.secondaryTelephones[0].countryCode),
					telephone: contactRequest.telephones[1].number,
					type: contactRequest.telephones[1].type,
					region: this.INDRA_isCountryCode(this.contactsInfo.secondaryTelephones[0].countryCode),
					tattoo: ''
				}];
			}

		} else {
			dataHolder.data.infoPax.secondaryTelephones = [];
		}

		this.bfmStorage.INDRA_setActiveBookedTrip(dataHolder);
		this.bfmStorage.observableCurrentBooking.next(this.bfmStorage.INDRA_getActiveBookedTrip());
		this.INDRA_handleClose();
	}

	INDRA_isCountryPrefix(prefix: string) {
		if (prefix) {
			const modifiedPrefix = prefix.split(':')[0];
			return modifiedPrefix && modifiedPrefix.includes('+') ? modifiedPrefix : '+' + modifiedPrefix;
		}
	}
	
	INDRA_isCountryCode(prefix: string) {
		if (prefix) {
			const modifiedPrefix = prefix.split(':')[1];
			return modifiedPrefix ? modifiedPrefix : '';
		}
	}
	
	INDRA_composePrefixFormValue(phoneCountryCode, prefixPhone) {
		if (!phoneCountryCode || !prefixPhone) return '';
		return prefixPhone + ':' + phoneCountryCode;
	}


	INDRA_showNotifications(style = null, message = null, showCloseBtn = true) {
		// if (!this.notif.show) {
		this.notif.show = true;
		message ? this.notif.message = message : null;
		style ? this.notif.style = style : null;
		showCloseBtn != null ? this.notif.showCloseBtn = showCloseBtn : null;
		this.cdr.detectChanges();
		// }
	}
	INDRA_hideNotifications() {
		this.notif.show = false;
	}

	isInvalid(field: string) {
		return this.formBookingContacts.group.get(field).invalid && this.triedToSubmit;
	}

	INDRA_getCountryCodesOptions(countryCodes) {
		const options = countryCodes.map(item => ({
			value: item.prefix + ':' + item.code,
			text: this.INDRA_getTranslation(COUNTRIES_TRANSLATION_KEY + item.code.toLowerCase()) + ' ' + item.prefix
		}));
		options.sort((a, b) => a.text.localeCompare(b.text));

		return options;
	}

	INDRA_printName(user) {
		if (user && user.firstName && user.lastName) {
			return (user.firstName + ' ' + user.lastName);
		} else {
			return '';
		}
	}

	INDRA_importUserData() {
		if (this.userInfo && this.userInfo.userProfile && this.userInfo.userProfile.contactPhone) {
			if (this.userInfo.userProfile.contactPhone.countryCode) {
				const phoneCountryCode = this.INDRA_getPrefix(this.userInfo.userProfile.contactPhone.countryCode);
				this.formBookingContacts.group.controls['phone_prefix'].setValue(phoneCountryCode || '');
			}
			this.formBookingContacts.group.controls['phone_number'].setValue(this.userInfo.userProfile.contactPhone.number || '');

			if (this.userInfo.userProfile.contactPhone.phoneType) {
				this.formBookingContacts.group.controls['phone_type'].setValue(this.userInfo.userProfile.contactPhone.phoneType || '');
			}
			

		}
		if (this.userInfo && this.userInfo.userProfile && this.userInfo.userProfile.contactEmail) {
			this.formBookingContacts.group.controls['email'].setValue(this.userInfo.userProfile.contactEmail || '');
			this.formBookingContacts.group.controls['verify_email'].setValue(this.userInfo.userProfile.contactEmail || '');
		}
	}

	
	INDRA_getPrefix(code) {
		const codeIdx = this.countryCodes.findIndex(element => element.prefix === '+' + code.replace(/^0+/, ''));
		if (codeIdx !== -1) {
			const convertedCode = '+' + code.replace(/^0+/, '') + ':' +  this.countryCodes[codeIdx].code;
			return convertedCode;
		}
	}

	private convertToCountryCodeFormat(str) {
		if (str) {
			const countryCode = Number(str).toString();
			return '+' + countryCode;
		}
		return null;
	}


	INDRA_handleReset() {
		this.INDRA_clearForm();
	}

	INDRA_handleDeleteCookies() {
		this.cookieService.delete(COOKIES_VAR_KEY_PASSENGER_DETAILS, '/booking');
		this.cookieService.delete(COOKIES_VAR_KEY_PASSENGER_CONTACT_DETAILS, '/booking');
		this.hasCookies = false;
	}

	 INDRA_DataPrivacyExternalUrl(): void {
		let externalLink: string;
		let market = sessionStorage.getItem('market') ? sessionStorage.getItem('market') : '';
		let lang = sessionStorage.getItem('language') ? sessionStorage.getItem('language') : '';
		switch (lang) {
			case 'pt':
				externalLink = 'https://www.flytap.com/pt-${market}/privacidade';
				externalLink = externalLink.replace(/\${market}/g, market.toLowerCase());
				break;
			case 'pt-br':
				externalLink = 'https://www.flytap.com/pt-br/privacidade';
				break;
			case 'en-us':
				externalLink = 'https://www.flytap.com/en-us/privacy';
				break;
			case 'fr':
				externalLink = 'https://www.flytap.com/fr-${market}/confidentialite';
				externalLink = externalLink.replace(/\${market}/g, market.toLowerCase());
				break;
			case 'es':
				externalLink = 'https://www.flytap.com/es-${market}/privacidad';
				externalLink = externalLink.replace(/\${market}/g, market.toLowerCase());
				break;
			case 'it':
				externalLink = 'https://www.flytap.com/it-it/privacy';
				break;
			case 'de':
				externalLink = 'https://www.flytap.com/de-${market}/datenschutzrichtlinie';
				externalLink = externalLink.replace(/\${market}/g, market.toLowerCase());
				break;
			case 'pl':
				externalLink = 'https://www.flytap.com/pl-pl/prywatnosci';
				break;
			case 'ru':
				externalLink = 'https://www.flytap.com/ru-ru/privacy';
				break;
			case 'zh':
				externalLink = 'https://www.flytap.com/zh-cn/privacy';
				break;
			case 'en':
			default:
				externalLink = 'https://www.flytap.com/en-${market}/privacy';
				externalLink = externalLink.replace(/\${market}/g, market.toLowerCase());
				break;
		}
		window.open(externalLink, '_blank');
	}

	INDRA_VerifyEmail(control: AbstractControl): { [key: string]: boolean } | null {
		if (!control.parent) {
			return null;
		}

		const formGroup = control.parent as FormGroup;
		const email = formGroup.get('email').value;
		const verifyEmail = control.value;

		if (!email || !verifyEmail) {
			return null;
		}

		return email === verifyEmail ? null : { 'emailMismatch': true };
	}
}
